import { render } from "./awaiting_email_confirmation.vue?vue&type=template&id=7dde296a"
import script from "./awaiting_email_confirmation.js?vue&type=script&lang=js"
export * from "./awaiting_email_confirmation.js?vue&type=script&lang=js"

import exportComponent from "/woodpecker/src/akkoma.dev/AkkomaGang/akkoma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__